import React from 'react';

const stack = [
  { category: "Backend", items: ["Spring Boot", "FastAPI", ".NET Core", "Node.js"] },
  { category: "AI / ML", items: ["Ollama", "qwen2.5", "LLaMA", "REST inference"] },
  { category: "Infrastructure", items: ["Docker", "Nginx", "Jenkins", "Portainer"] },
  { category: "Databases", items: ["PostgreSQL", "Redis", "SQLite"] },
];

export default function Stack() {
  return (
    <section id="stack" className="py-24 px-6 bg-ink">
      <div className="max-w-5xl mx-auto">
        <p className="text-accent font-body text-sm tracking-[0.2em] uppercase mb-4">Stack</p>
        <h2 className="font-display text-4xl text-cream mb-16">Tools I work with</h2>

        <div className="grid md:grid-cols-4 gap-8">
          {stack.map(({ category, items }) => (
            <div key={category}>
              <p className="font-body text-xs text-accent tracking-[0.15em] uppercase mb-4 border-b border-accent/20 pb-2">
                {category}
              </p>
              <ul className="space-y-2">
                {items.map(item => (
                  <li key={item} className="font-body text-sm text-cream/70 hover:text-cream transition-colors">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
